import BoxList from './BoxList';

export default BoxList;
